import { render } from "./CaseComunication.vue?vue&type=template&id=375fb0ec"
import script from "./CaseComunication.vue?vue&type=script&lang=js"
export * from "./CaseComunication.vue?vue&type=script&lang=js"

import "./CaseComunication.vue?vue&type=style&index=0&id=375fb0ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__